import React, { useState } from "react";
import { useAppSelector } from "../../../context-store";
import DepartmentModel from "../../../models/company/department/response/DepartmentModel";
import DepartmentRequestModel from "../../../models/company/department/request/DepartmentRequestModel";
import { PageModeEnum } from "../../../models/enums/PageModeEnum";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TableContainer from "@mui/material/TableContainer";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableHead from "@mui/material/TableHead";

interface DepartmentGridProps {
    departmentList: DepartmentModel[];
    totalSize: number;
    currentPage: number;
    pagesize: number;
    sortColumn: string;
    sortDirection: "asc" | "desc";
    pageSizesList: number[];
    departmentNameFilterValue: string;
    onDepartmentAction: (row: DepartmentRequestModel, actionType: string) => void;
    onPageChangeAction: (newPage: number) => void;
    onPageSizeChangeAction: (newPageSize: number) => void;
    onSortAction: (newSortColumn: string, sortDir: string) => void;
    onFilterAction: (filterColumn: string, filterValue: string) => void;
}

const DepartmentGridComponent = (props: DepartmentGridProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [departmentNameFilter, setDepartmentNameFilter] = useState<string>(props.departmentNameFilterValue);
    const ActionFormatter = (
        cell: any,
        row: DepartmentModel,
        rowIndex: number
    ) => {
        return (
            <div className="text-center-align">
                <a onClick={() => { editDepartment(row); }}>Edit</a>
            </div>
        );
    };

    const editDepartment = (row: DepartmentModel) => {
        if (loggedInUser !== null) {
            let departmentRequestModel: DepartmentRequestModel = {
                departmentId: row.departmentId,
                departmentName: row.departmentName,
                description: row.description,
                companyId: loggedInUser?.profileId,
                userId: loggedInUser?.userId
            }
            props.onDepartmentAction(departmentRequestModel, PageModeEnum.Edit);
        }
    };    

    const columnsDepartments = [
        { Key: "DepartmentName", text: "Department Name", sort: true, searchable: true },
        { Key: "Description", text: "Description", sort: false, searchable: false },
        { Key: "Actions", text: "Actions", sort: false, searchable: false, formatter: ActionFormatter }
    ];

    const createSortHandler = (property: string) => (event: React.MouseEvent) => {
        props.onSortAction(property, props.sortDirection === "asc" ? "desc" : "asc")
    };

    const handleChangePage = (event: any, newPage: number) => {
        props.onPageChangeAction(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        props.onPageSizeChangeAction(parseInt(event.target.value, 10));
    };

    const filterOnChange = (key: string, value: string) => {
        setDepartmentNameFilter(value);
        if ((value && value.length > 2) || value === "") {
            props.onFilterAction(key, value);
        }
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {columnsDepartments.map((column: any) => (
                                    <TableCell key={column.key} className="table-header-cell">
                                        {column.sort &&
                                            <TableSortLabel
                                                active={props.sortColumn === column.key}
                                                direction={props.sortColumn === column.key ? props.sortDirection : "asc"}
                                                onClick={createSortHandler(column.key)}>
                                                {column.text}
                                            </TableSortLabel>
                                        }
                                        {column.searchable &&
                                            <input type="text" placeholder="search" className="mat-header-filter-input" value={departmentNameFilter}
                                                onClick={(e) => e.stopPropagation()} onChange={(e) => filterOnChange(column.key, e.target.value)}></input>
                                        }
                                        {!column.sort &&
                                            <span>{column.text}</span>
                                        }
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.departmentList.map((department: DepartmentModel, index) => (
                                <TableRow
                                key={index}
                                sx={{
                                    backgroundColor: index % 2 === 0 ? 'white' : '#f5f5f5' // even rows white, odd rows light gray
                                }}
                                >
                                    <TableCell>{department.departmentName}</TableCell>
                                    <TableCell>{department.description}</TableCell>                                
                                    <TableCell>
                                        <a onClick={() => { editDepartment(department); }} title="Edit Department">
                                            <i className="fa fa-edit grid-icon blue"></i>
                                        </a>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={props.pageSizesList}
                    component="div"
                    count={props.totalSize}
                    rowsPerPage={props.pagesize}
                    page={props.currentPage - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </div>
    );
};
export default DepartmentGridComponent;